module.exports = __webpack_public_path__ + "static/shavit-hex-c5ab1b5f81f90f0393a60df9a33b7c00.png";